export enum BannerEventActionType {
  SponsoringBannerHovered = 'banner_hovered',
  SponsoringBannerClicked = 'banner_clicked',
}
